export const INCIDENT = 'incident';
